import styled from "styled-components";
import { SCREEN } from "assets";

export const AgencyProfileFormSec1Styled = styled.div`
  input[type="text"] {
    width: 100%;
    height: 35px;

    border-radius: 4px;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.6);
    padding: 8px;
  }
  .box_label {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .label {
      min-width: 100px;
      margin-right: 10px;
    }
    .item_checkout {
      margin-right: 8px;
    }
  }
  .button_layer {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: ${SCREEN.PHONE}) {
    .box_label {
      flex-direction: column;
      align-items: flex-start;
      .label {
        text-align: left;
      }
    }
  }
`;
